import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
// import VolumeOffRoundedIcon from '@mui/icons-material/VolumeOffRounded';

// import ThemeContext from '../../../config/themeContext';
import VolumenOffIcon from '../icons/VolumenOffIcon';
import VolumenOnIcon from '../icons/VolumenOnIcon';

export default function AdVolume({ config, adVideo }) {
  const [muted, setMuted] = useState(config.muted);
  // const theme = useContext(ThemeContext);

  function handlerClick() {
    if (muted) {
      adVideo.unmute();
    } else {
      adVideo.mute();
    }
    setMuted(!muted);
  }

  return (
    <div className="tpx-ext-volume">
      <div className="txp-ext-volume-btn" onClick={handlerClick}>
        {!muted ? <VolumenOnIcon /> : <VolumenOffIcon />}
      </div>
    </div>
  );
}

AdVolume.propTypes = {
  config: PropTypes.object.isRequired,
  adVideo: PropTypes.object.isRequired,
};
